export interface PatentProfileByIdsRequest {
    patent_ids: string[];
    lang?: string;
}

export interface PatentProfileByKeywordRequest {
    q: string
    simple: boolean
}
export interface PatentImageInfoDto {
    /**
     * 图片标签
     */
    labels: string[];
    /**
     * 是否已提取
     */
    extracted: boolean;
    /**
     * 专利ID
     */
    patent_id: string;
    /**
     * 图片标题代码
     */
    fig_title_code: string;
    /**
     * 缩略图URL (240px)
     */
    fulltext_image240_url: string;
    /**
     * 官方尺寸
     */
    official_size: string;
    /**
     * 图片ID
     */
    image_id: string;
    /**
     * 图片来源
     */
    image_from: string;
    /**
     * 存储路径
     */
    storage_path: string;
    /**
     * 源图片类型
     */
    source_image_type: string;
    /**
     * 图片类型
     */
    image_type: string;
    /**
     * 是否已提取
     */
    is_extracted: boolean;
}

export type PatentProfile = {
    TITLE: string;
    PN: string;
    ANCS: string[];
    APD: string;
    APN: string;
    PBD: string;
    PATENT_ID: string;
    EXDT: string;
    LEGAL_STATUS: number[];
    SIMPLE_LEGAL_STATUS: number;
    FAMILY_ID: string
    ABST: Record<string, string>
    ABST_LANG: string;
    PDF_IMAGE: PatentImageInfoDto[];
    IN: string[];
    SIMPLE_FAMILY_LIST: Array<{ PATENT_ID: string; PN: string }>;
}

export type PatentProfileByIdsResponse = Record<string, PatentProfile>;

export type PatentProfileByKeywordResponse = {
    patent_info: PatentProfile
}

/**
 * 根据专利号获取专利概要信息 API
 */
export interface PatentProfileByIdsApi {
    /**
     * 根据专利号获取专利概要信息
     * @param data
     * @returns
     */
    getPatentProfileByIds: (data: PatentProfileByIdsRequest) => Promise<PatentProfileByIdsResponse>;

    /**
     * 根据关键词获取专利概要信息
     * @param data
     * @returns
     */
    getPatentProfileByKeyword: (data: PatentProfileByKeywordRequest) => Promise<PatentProfileByKeywordResponse>;
}

export const PatentProfileByIdsApi = Symbol('PatentProfileByIdsApi');
